import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FocusService {
  focusHeaderAction(): void {
    const shoppingTitle = document.querySelector('#shopping-title') as HTMLElement;
    const shoppingLink = document.querySelector('#shopping-link') as HTMLElement;

    const element = shoppingLink || shoppingTitle;
    element?.focus();
    element?.blur();
  }

  focusHeaderFirstItem(): void {
    const header = document.querySelector('header') as HTMLElement;
    const firstFocusableElement = header?.querySelector<HTMLElement>('button,a[href],[tabindex]');

    if (firstFocusableElement) {
      firstFocusableElement.focus();
    } else {
      this.focusHeaderAction();
    }
  }

  removeMatDialogFocus(): void {
    const cdkVisuallyHiddenList = document.querySelectorAll('.cdk-visually-hidden');
    const matMdcDialogContainer = document.querySelectorAll('.mat-mdc-dialog-container');

    const nodeList = [...Array.from(cdkVisuallyHiddenList), ...Array.from(matMdcDialogContainer)];

    nodeList.forEach((element) => {
      element.removeAttribute('tabIndex');
    });
  }
}
